import { Firestore, Firebase } from '../lib/firebase';
import {
    UserController
} from 'controllers';

export const getShipmentByDate = async ({ year, monthNumber, countryCode }) => {

    const codeCollection = Firestore.collection('config')
        .doc('distribution')
        .collection(`${countryCode}_shipment_weeks`)
        .doc(`${year}-${monthNumber}`);

    try {
        const snapshot = await codeCollection.get();
        return snapshot.data();
    } catch (error) {
        console.log(error);
    }
}
export const getShipmentListsByDate = async ({ year, monthNumber, weekCode, countryCode }) => {
    const codeCollection = Firestore.collection('config')
        .doc('distribution')
        .collection(`${countryCode}_shipment_weeks`)
        .doc(`${year}-${monthNumber}`)
        .collection(`${countryCode}_${year}_${monthNumber}_${weekCode}`);

    try {
        const res = await codeCollection.get();
        const list = [];
        for (const listItem of res.docs) {
            const customer = await UserController.getUserById(listItem.id);
            list.push({ id: listItem.id, ...listItem.data(), ...customer });
        }

        const sortedList = list.sort(function (a, b) {
            return a.index - b.index;
        });;

        return sortedList;
    } catch (error) {
        console.log(error);
    }
}

export const getPartnersByMarket = async (countryCode) => {

    const codeCollection = Firestore.collection('config')
        .doc('distribution')

    try {
        const snapshot = await codeCollection.get();
        const result = snapshot.data();
        return result[`${countryCode}_partners`];
    } catch (error) {
        console.log(error);
    }
}

export const createShipment = async ({ payload, month, year, countryCode }) => {

    const codeCollection = Firestore.collection('config')
        .doc('distribution')
        .collection(`${countryCode}_shipment_weeks`)
        .doc(`${year}-${month}`);

    try {
        await codeCollection.set(payload, { merge: true });
        return true;
    } catch (error) {
        console.log(error);
    }
    return false;
}

export const setCustomersDocuments = async ({ shipmentList, week, month, year, countryCode }) => {

    for (const user of shipmentList) {
        const { id, payload } = user;

        try {
            const codeCollection = Firestore.collection('config')
                .doc('distribution')
                .collection(`${countryCode}_shipment_weeks`)
                .doc(`${year}-${month}`)
                .collection(`${countryCode}_${year}_${month}_${week}`)
                .doc(id)
            await codeCollection.set(payload, { merge: true });

        } catch (error) {
            console.log(error);
            throw new Error(`Something went wrong! Please contact tech support. Error: ${error.message}`)
        }
    }
}

export const editShipment = async ({ payload, month, year, countryCode }) => {

    const codeCollection = Firestore.collection('config')
        .doc('distribution')
        .collection(`${countryCode}_shipment_weeks`)
        .doc(`${year}-${month}`);

    try {
        await codeCollection.set(payload, { merge: true });
        return true;
    } catch (error) {
        console.log(error);
    }
    return false;
}

export const deleteShipment = async ({ payload, month, year, countryCode }) => {

    const codeCollection = Firestore.collection('config')
        .doc('distribution')
        .collection(`${countryCode}_shipment_weeks`)
        .doc(`${year}-${month}`);

    try {
        await codeCollection.update({ [`${payload.week}.${payload.partner}`]: Firebase.firestore.FieldValue.delete() });

        return true;
    } catch (error) {
        console.log(error);
    }
    return false;
}

// create the payload by partners
export const retrievePayloadByWeek = async ({ week, monthNumber, year, countryCode, pickedPartner }) => {

    const monthShipment = await getShipmentByDate({ year, monthNumber, countryCode });

    const data = monthShipment[week][pickedPartner];
    const payload = {
        status: 'to_do', label: [],
        return_date: data.return_date,
        shipment_date: data.shipment_date,
        distribution_partner: pickedPartner,
        created_at: +new Date(),
        shipment_week: week
    }

    return payload;
}

